module.exports = "/_next/static/images/9-b533574fd464d81912062736a7699afc.png";